// Report periods are restricted to fully completed months — never the current or a
// future month (their data is incomplete). The latest selectable period is the
// previous calendar month. Shared by the New Report and Clone dialogs.

const now = new Date();
const CURRENT_YEAR = now.getFullYear();
const CURRENT_MONTH = now.getMonth() + 1; // 1-12

export const LAST_COMPLETED_MONTH = CURRENT_MONTH === 1 ? 12 : CURRENT_MONTH - 1;
export const LAST_COMPLETED_YEAR = CURRENT_MONTH === 1 ? CURRENT_YEAR - 1 : CURRENT_YEAR;

/** True if (year, month) is a fully completed month (strictly before the current month). */
export function isMonthCompleted(year: number, month: number): boolean {
  return year < CURRENT_YEAR || (year === CURRENT_YEAR && month < CURRENT_MONTH);
}

/** The most recent `count` completed months (newest first), for a single period picker. */
export function completedMonths(count = 24): { year: number; month: number }[] {
  const out: { year: number; month: number }[] = [];
  let y = LAST_COMPLETED_YEAR;
  let m = LAST_COMPLETED_MONTH;
  for (let i = 0; i < count; i++) {
    out.push({ year: y, month: m });
    m -= 1;
    if (m < 1) { m = 12; y -= 1; }
  }
  return out;
}
